import { render, staticRenderFns } from "./TopAgents.vue?vue&type=template&id=1412a65a&"
import script from "./TopAgents.vue?vue&type=script&lang=js&"
export * from "./TopAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports